import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/zengdai/Workspace/vimwiki/Projects/Blogger/blogv3/src/components/posts-layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Reading notes from `}<a parentName="p" {...{
        "href": "https://www.manning.com/books/micro-frontends-in-action"
      }}>{`Micro Frontends in Action`}</a>{` to get background for webpack 5 (`}<a parentName="p" {...{
        "href": "#nowait"
      }}>{`TL;DR`}</a>{`)...`}</p>
    <h1>{`Micro Frontends in Action (⭐⭐⭐)`}</h1>
    <p>{`When things gets bigger, you divided it and give it autonomy and trust. Yet during reading, I got to know Webpack Federation even more interesting!`}</p>
    <h1>{`Specialist vs Cross Functional Team`}</h1>
    <p><strong parentName="p">{`Old fashion`}</strong>{`: divide team based on their skills.`}</p>
    <p><strong parentName="p">{`New fashion`}</strong>{`: vertically divide into each small full stack group.`}</p>
    <p>{`In old fashion team provides modules/functions, knowledge, tools and asistance. However, they mostly focus on their own target. In real world many new features require full stack integration from front through to backend, therefore with too many dependencies and project moves slow. While with new vertical fashion, team is an independent `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`startup`}</code>{` group (localized decision and management) and move faster. Some sharing cross team can help reduce duplication. Good or bad, I think it's very feasible for agile UX focus features. However, backend world and many other complicate system might still be leaning to old fashion since simply a tool or an infrastructure might cost a whole team effort and these parts are very commonly shared.`}</p>
    <p>{`Besides hiring, I think the keys of success for micro frontend structure are sharing and communications. Share to reuse knowledge/effort as much as possible. Communication and even compromising to avoid conflicting in integration.`}</p>
    <h1>{`Micro Frontend Framework`}</h1>
    <p>{`Basically, a framework that can integrates pages and page elemnts (fragments) into a solid normal web page. `}</p>
    <h2>{`Page Split`}</h2>
    <p>{`Old MPA way to split. User experience bad.`}</p>
    <h2>{`iframe?`}</h2>
    <p>{`Performance, layout and accessibility make it not feasible. However, how Spotify uses for desktop application is very interesting to give a `}<a parentName="p" {...{
        "href": "https://www.quora.com/How-is-JavaScript-used-within-the-Spotify-desktop-application-Is-it-packaged-up-and-run-locally-only-retrieving-the-assets-as-and-when-needed-What-JavaScript-VM-is-used/answer/Mattias-Petter-Johansson"
      }}>{`read`}</a>{`. It's Chromium Embedded Framework (CEF) in V8 which is somewhat like iframe (think about open multiple chrome tab windows in your app). It has interesting name Spotlet. Communication is through REST API style.`}</p>
    <h2>{`Ajax`}</h2>
    <p>{`Load and assembly the page. Still cannot solve namespace issues and nasty way to share/communicate in Javascript. Too many queries for different features. One option is to put this assembly in server side (SSR).`}</p>
    <h2>{`Nginx or CDN Providers' Tricks`}</h2>
    <p>{`Server side templating or includes by configuring nginx, old tech to integrate pages/fragments and `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`nginx.conf`}</code>{` form to fill. Many CDN providers also support similar stuff, just do: `}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "html"
    }}><pre parentName="div" {...{
        "className": "language-html"
      }}><code parentName="pre" {...{
          "className": "language-html"
        }}><span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`<`}</span><span parentName="span" {...{
                "className": "token namespace"
              }}>{`esi:`}</span>{`include`}</span>{` `}<span parentName="span" {...{
              "className": "token attr-name"
            }}>{`src`}</span><span parentName="span" {...{
              "className": "token attr-value"
            }}><span parentName="span" {...{
                "className": "token punctuation attr-equals"
              }}>{`=`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`"`}</span>{`...`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`"`}</span></span>{` `}<span parentName="span" {...{
              "className": "token punctuation"
            }}>{`/>`}</span></span></code></pre></div>
    <p>{`Not good for server side load. Communication between pages? No way!`}</p>
    <h2>{`Client Side Composition`}</h2>
    <p>{`Client side do the integration and we only take care of traffic. Use webcomponent/custom html element to implement. `}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "javascript"
    }}><pre parentName="div" {...{
        "className": "language-javascript"
      }}><code parentName="pre" {...{
          "className": "language-javascript"
        }}><span parentName="code" {...{
            "className": "token keyword"
          }}>{`class`}</span>{` `}<span parentName="code" {...{
            "className": "token class-name"
          }}>{`MyNewComponent`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`extends`}</span>{` `}<span parentName="code" {...{
            "className": "token class-name"
          }}>{`HTMLElement`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
    `}<span parentName="code" {...{
            "className": "token function"
          }}>{`constructor`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
        `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// creation`}</span>{`
    `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{`
    `}<span parentName="code" {...{
            "className": "token function"
          }}>{`disconnectedCallback`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
        `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// destroy`}</span>{`
    `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{`
    `}<span parentName="code" {...{
            "className": "token function"
          }}>{`connectedCallback`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
        `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// this.innerHTML = \`<fancy page/>\``}</span>{`
    `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{`
    `}<span parentName="code" {...{
            "className": "token function"
          }}>{`attributeChangedCallback`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
        `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// this.getAttribute("my-attr");`}</span>{`
    `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{`

`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// somewhere`}</span>{`
window`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`customElements`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`define`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"my-new-component"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` MyNewComponent`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span></code></pre></div>
    <p>{`Old browser not support (problematic polyfill). Some virtual DOM framework (e.g. React) might have `}<a parentName="p" {...{
        "href": "https://custom-elements-everywhere.com/#react"
      }}>{`issues`}</a>{` fully supporting it.`}</p>
    <p>{`Shadow DOM can help isolate your JS/CSS!`}</p>
    <p>{`Since it's in the same html page, communication is fine. Following modern framework's pattern (e.g. Redux), it's easy (think of parent as main page and children as your web component:`}</p>
    <p><code parentName="p" {...{
        "className": "language-text"
      }}>{`parent`}</code>{` --immutable attribute--> `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`children`}</code>{` `}</p>
    <p><code parentName="p" {...{
        "className": "language-text"
      }}>{`children`}</code>{` --event report--> `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`parent`}</code>{` `}</p>
    <p>{`Again, for communication, using web component or not, please strictly follow e.g. Redux pattern.`}</p>
    <p>{`Occasionally, pub/sub etc. can be used for `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`long distance`}</code>{` call 😺. `}</p>
    <h3>{`App Shell/Meta Framework`}</h3>
    <p>{`As in PWA, Cached skeleton (routers and some common things). Keep it lean and simple. Author implemented a toy example to illustrate but actually this skeleton should also handle Meta, error/failure handling, memory/resource management, performance profiling and communication. Some common tasks like auth, polyfill, analytic & tag as well. Actually there are a wheel on github: `}<a parentName="p" {...{
        "href": "https://github.com/single-spa/single-spa"
      }}>{`single-spa`}</a>{`. `}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "text"
    }}><pre parentName="div" {...{
        "className": "language-text"
      }}><code parentName="pre" {...{
          "className": "language-text"
        }}>{`Key idea is to lazily load each SPA and maintain them in the same page (soft transition to each routes).`}</code></pre></div>
    <p>{`However, interactivity is issue with loading/slow page. Later author comes back to mixture of server side and client side.`}</p>
    <h1>{`Server Sider + Client Side`}</h1>
    <p>{`This is called universal rendering in book. Useful for case when first page load matters. `}<a parentName="p" {...{
        "href": "https://ara-framework.github.io/website/"
      }}>{`Ara Framework`}</a>{` will be the wheel.
Personal feeling this universal rendering idea creates extra complexity and why would I entangle components like this instead of keeping route path boundary at first place. First loading page can be solved by many other better ways.`}</p>
    <h1>{`Frontend Arch Decision Tree`}</h1>
    <p>{`Also see `}<a parentName="p" {...{
        "href": "https://www.angulararchitects.io/aktuelles/a-software-architects-approach-towards/"
      }}>{`here`}</a>{`.`}</p>
    <p>{`Doc vs Content Spectrum:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "text"
    }}><pre parentName="div" {...{
        "className": "language-text"
      }}><code parentName="pre" {...{
          "className": "language-text"
        }}>{`Doc            <----  ---->         Content
Web Site            PWA               Web App
SSR                                     CSR`}</code></pre></div>
    <h1>{`Performance`}</h1>
    <p>{`Build theirs own metrics for teams and aligned together. Common big framework vendor code costs so shares centerilized big vendor code. Sharing cause problem of deploy lock when version updates, so tools like `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`webpack.DllReferencePlugin`}</code>{` comes to play. `}</p>
    <h1>{`Pattern Library`}</h1>
    <p>{`Some philosophy of design decision for centralized/localized library. `}</p>
    <h1>{`Team Boundaries`}</h1>
    <p>{`Like the philosophy part, many similar discussion in sw engineering philosophy. Again I think combine autonomy with traditional sw team structure is the way to go. UX/frontend/application team does full autonomy for fast iteration while other like backend/service/infra team does domain/functional boundary. Of course communication cross-team is very important. Guidance, tech blueprint, are also good ways to help tech decision.`}</p>
    <p>{`There're also resources for such checklist:`}</p>
    <h1>{`Migration`}</h1>
    <p>{`Some points discussed before but in great details.`}</p>
    <div id='nowait' />
    <h1><a parentName="h1" {...{
        "href": "https://webpack.js.org/concepts/module-federation/"
      }}>{`Webpack Federation`}</a></h1>
    <p><a parentName="p" {...{
        "href": "https://indepth.dev/posts/1173/webpack-5-module-federation-a-game-changer-in-javascript-architecture"
      }}>{`This`}</a>{` shows how to practically start a micro frontend project e.g. as in this repo: `}<a parentName="p" {...{
        "href": "https://github.com/mizx/mfe-webpack-demo"
      }}>{`https://github.com/mizx/mfe-webpack-demo`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      